// extracted by mini-css-extract-plugin
export default {"label":"item_label__GLe-m","selected":"item_selected__ALXMc"};